<template>
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 84.000000 75.000000" preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,75.000000) scale(0.100000,-0.100000)" stroke="none">
        <path d="M380 673 c-94 -48 -62 -163 45 -163 48 0 78 18 94 58 31 74 -61 144 -139 105z"/>
        <path d="M323 404 c-57 -29 -67 -55 -71 -193 -4 -111 -2 -126 14 -138 25 -18 293 -18 318 0 16 12 18 27 14 138 -4 139 -14 165 -73 193 -44 21 -159 21 -202 0z"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'IconEval',
}
</script>

<style lang="scss" scoped>
</style>